import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';

import { Typography, Empty } from 'antd';

import LearningAdminModuleSeriesList from '../containers/LearningAdminModuleSeriesListContainer';

const { Title, Text } = Typography;

const LearningAdminModulesGridScreen = ({
  moduleSerieTypes,
  total,
  setShowList,
  setGlobalTotal,
  defaultOrderModuleSeries,
  defaultLimitModuleSeries,
  totalRecommended,
  totalMoreContent,
  view,
  activeKey,
  trackerActions,
  ...props
}) => {
  useEffect(() => {
    setShowList(total);
    setGlobalTotal(total);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total]);

  return (
    <Translation>
      {(t) => (
        <>
          {total === 0 && (
            <div className='learning-empty'>
              <Empty
                description={
                  <>
                    <Title level={3} className='learning-empty-title'>
                      {t('learning_empty_title')}
                    </Title>
                    <Text>{t('learning_empty_description')}</Text>
                  </>
                }
              />
            </div>
          )}

          {moduleSerieTypes.map((x) => (
            <LearningAdminModuleSeriesList
              totalRecommended={totalRecommended}
              totalMoreContent={totalMoreContent}
              total={total}
              action={x.action}
              value={x.value}
              defaultOrderModuleSeries={defaultOrderModuleSeries}
              defaultLimitModuleSeries={defaultLimitModuleSeries}
              view={view}
              activeKey={activeKey}
              trackerActions={trackerActions}
            />
          ))}
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModulesGridScreen);

Logger.log('silly', `LearningAdminModulesGridScreen loaded.`);
